import { View, StyleSheet, TouchableOpacity } from 'react-native';
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import QText from './QText';
import { useTheme } from 'react-native-paper';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import DashboardIcon from './Icons/DashboardIcon';
import ManageQueueIcon from './Icons/ManageQueueIcon';
import QRCodeIcon from './Icons/QRCodeIcon';

const BottomBar = ({ navigation, screen, visible = true }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const role = useSelector((state) => state.role);

  // Don't render if not visible or if user is business
  if (!visible || role === 'business') {
    return null;
  }

  return (
    <View
      style={[
        styles.footerBarContainer,
        {
          backgroundColor: theme.colors.onBackgroundDark,
          borderTopColor: theme.colors.OnBackgroundDarkBorder,
        },
      ]}
    >
      <View style={[styles.btnContainer, role === 'user' && { width: '50%' }]}>
        <TouchableOpacity
          style={styles.btnTouch}
          disabled={screen === 'dashboard' ? true : false}
          onPress={() => {
            navigation.push('DashboardScreen');
          }}
        >
          <DashboardIcon
            color={
              screen === 'dashboard'
                ? theme.colors.primary
                : theme.colors.disabledIconColor
            }
          />
          <QText
            style={
              screen === 'dashboard'
                ? {
                    color: theme.colors.primary,
                  }
                : {}
            }
          >
            {t('dashboard')}
          </QText>
        </TouchableOpacity>
      </View>

      {role === 'user' && (
        <View style={[styles.btnContainer, { width: '50%' }]}>
          <TouchableOpacity
            style={styles.btnTouch}
            disabled={screen === 'qrCode' ? true : false}
            onPress={() => {
              navigation.push('QRCodeScreen');
            }}
          >
            <QRCodeIcon
              color={
                screen === 'qrCode'
                  ? theme.colors.primary
                  : theme.colors.disabledIconColor
              }
            />

            <QText
              style={
                screen === 'qrCode'
                  ? {
                      color: theme.colors.primary,
                    }
                  : {}
              }
            >
              {t('qr_code')}
            </QText>
          </TouchableOpacity>
        </View>
      )}

      {role === 'business' && (
        <View style={styles.btnContainer}>
          <TouchableOpacity
            style={styles.btnTouch}
            disabled={screen === 'myQueue' ? true : false}
            onPress={() => {
              navigation.push('MyQueueScreen');
            }}
          >
            <ManageQueueIcon
              color={
                screen === 'myQueue'
                  ? theme.colors.primary
                  : theme.colors.disabledIconColor
              }
            />
            <QText
              style={
                screen === 'myQueue'
                  ? {
                      color: theme.colors.primary,
                    }
                  : {}
              }
            >
              {t('managed_queue')}
            </QText>
          </TouchableOpacity>
        </View>
      )}
    </View>
  );
};

BottomBar.propTypes = {
  navigation: PropTypes.any,
  screen: PropTypes.string,
  visible: PropTypes.bool,
};

const styles = StyleSheet.create({
  footerBarContainer: {
    width: '100%',
    height: 80,
    flexDirection: 'row',
    position: 'absolute',
    bottom: 0,
    borderTopWidth: 1,
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
  },
  btnContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    width: '50%',
  },
  btnTouch: {
    alignItems: 'center',
    justifyContent: 'center',
  },
});

export default memo(BottomBar);
